import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=73b8d7cf&scoped=true&"
import script from "./CustomerEdit.vue?vue&type=script&lang=ts&"
export * from "./CustomerEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8d7cf",
  null
  
)

export default component.exports